import Axios from 'axios';
import download from 'downloadjs';

export type ImportMode = 'new' | 'update';

export async function postRateImportFile<T>(
  url: string,
  file: File,
  extraFields?: Record<string, string>
): Promise<T> {
  const formData = new FormData();
  formData.append('file', file);
  Object.entries(extraFields ?? {}).forEach(([key, value]) => {
    formData.append(key, value);
  });
  const res = await Axios.post(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
}

// Underscore separates structural fields; dash replaces spaces inside a name, never the reverse
export function sanitizeFilenamePart(value: string): string {
  return value.replace(/[\\/:*?"<>|]/g, '').trim().replace(/\s+/g, '-');
}

export async function downloadRateTemplate(
  url: string,
  filename: string,
  params?: Record<string, string | undefined>
) {
  const res = await Axios.get(url, {
    responseType: 'arraybuffer',
    params,
  });
  download(
    res.data,
    filename,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  );
}
